import { IBxpWebStargateClient } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client';
import { CustomerSupportTicketCommentMutationResponse } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

export const createMoveTicketComment = async ({
	stargateClient,
	issueId,
	comment,
}: {
	stargateClient: IBxpWebStargateClient;
	issueId: string;
	comment: string;
}) => {
	const query = `
            mutation AddComment($IssueID: String!, $message: String!) {
                customerSupport {
                    addComment(input: {issueKey: $IssueID, message: $message}) {
                        message
                        author {
                            user {
                                accountId
                                name
                                picture
                                __typename
                            }
                            __typename
                        }
                        createdDate {
                            dateTime
                            friendly
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
            }
        `;

	const response =
		await stargateClient.getCspGraphqlRequest<CustomerSupportTicketCommentMutationResponse>({
			request: JSON.stringify({
				query: query,
				variables: {
					IssueID: issueId,
					message: comment,
				},
			}),
		});

	return response;
};
